// extracted by mini-css-extract-plugin
export var childrenContainer = "_3f-0";
export var virtualScrollArea = "_3f-1";